const KeyWithKeyRing = ({ className = '' }) => (
  <svg
    width="59"
    height="65"
    viewBox="0 0 59 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M31.6502 7.92541C20.5308 11.3832 14.3199 23.1992 17.7777 34.3186C21.2355 45.438 33.0515 51.6489 44.1709 48.1911C55.2903 44.7333 61.5012 32.9173 58.0434 21.7979C54.5856 10.6785 42.7696 4.46758 31.6502 7.92541ZM35.4831 20.2483C33.2802 20.9345 30.9372 19.7022 30.2531 17.4993C29.5669 15.2965 30.7991 12.9535 33.002 12.2693C35.2049 11.5831 37.5479 12.8154 38.232 15.0183C38.9182 17.2211 37.6859 19.5641 35.4831 20.2483Z"
      fill="#0A0777"
    />
    <path
      d="M17.1908 26.4283C10.2545 24.4006 6.2774 17.1347 8.30511 10.1984C10.3328 3.26422 17.5988 -0.714949 24.533 1.31276"
      stroke="#0A0777"
      strokeWidth="0.442474"
      strokeMiterlimit="10"
    />
    <path
      d="M12.1853 60.5241L5.77243 64.7835L2.71851 57.7566L9.85876 33.3354L19.3255 36.1029L12.1853 60.5241Z"
      fill="#FFCCEF"
    />
    <path
      d="M28.4606 20.0116L10.8335 14.8578C7.76514 13.9614 4.55048 15.7213 3.65202 18.7896L0.237473 30.4695C-0.658923 33.5379 1.1009 36.7526 4.16925 37.651L21.7963 42.8048C24.8647 43.7012 28.0793 41.9414 28.9778 38.873L32.3923 27.1931C33.2887 24.1247 31.5289 20.9101 28.4606 20.0116ZM15.9296 30.144C13.7638 29.5113 12.5212 27.2405 13.1538 25.0747C13.7864 22.9089 16.0573 21.6663 18.2231 22.299C20.3889 22.9316 21.6315 25.2024 20.9988 27.3682C20.3662 29.534 18.0953 30.7766 15.9296 30.144Z"
      fill="#FFCCEF"
    />
    <path
      d="M1.45752 49.4169L8.89245 61.4204L14.1905 43.3091L1.45752 49.4169Z"
      fill="#FFCCEF"
    />
    <path
      d="M3.0896 43.8369L10.5245 55.8424L15.8205 37.729L3.0896 43.8369Z"
      fill="#FFCCEF"
    />
    <path
      d="M26.9577 21.8549L11.1052 17.2193C8.72388 16.523 6.22896 17.8889 5.53262 20.2702L2.61998 30.2307C1.92364 32.612 3.28957 35.1069 5.67086 35.8032L21.5233 40.4388C23.9046 41.1352 26.3996 39.7692 27.0959 37.3879L30.0085 27.4275C30.7049 25.0462 29.339 22.5513 26.9577 21.8549Z"
      stroke="#0A0777"
      strokeWidth="0.442474"
      strokeMiterlimit="10"
    />
    <path
      d="M9.07996 59.8116L6.77612 61.4477L5.71899 58.8286L11.0026 40.7544L14.3656 41.7373L9.07996 59.8116Z"
      stroke="#0A0777"
      strokeWidth="0.442474"
      strokeMiterlimit="10"
    />
    <path
      d="M7.95059 39.8618L9.16845 40.2183L3.88487 58.2905L3.17188 58.7974"
      stroke="#0A0777"
      strokeWidth="0.442474"
      strokeMiterlimit="10"
    />
    <path
      d="M24.533 1.3125C31.4692 3.34021 35.4463 10.6062 33.4186 17.5424C31.3909 24.4787 24.125 28.4558 17.1887 26.4281"
      stroke="#0A0777"
      strokeWidth="0.442474"
      strokeMiterlimit="10"
    />
  </svg>
);

export default KeyWithKeyRing;
